export const getProfileOwnerName = (user, t) => (
  String(user?.name || '').trim() || t('businesses.ownClient')
);

export const getBusinessClientName = (business, user, t) => (
  business?.client?.name ||
  business?.clientName ||
  getProfileOwnerName(user, t)
);
